import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../hooks/auth'

export function SignoutPage() {
  const { signOut } = useAuth()

  const navigate = useNavigate()

  useState(() => {
    signOut()
    navigate('/signin')
  })

  return null
}
